import { render, staticRenderFns } from "./batch-cost.vue?vue&type=template&id=9ebd2256&"
import script from "./batch-cost.vue?vue&type=script&lang=js&"
export * from "./batch-cost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports